import { MutationTree } from 'vuex';
import {
  SET_EVENTS_DATA,
  SET_UPDATE_SHORTLISTED_EVENT_DATA
} from './mutation-types';
import State from './state';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IUpcomingEvents } from '../../../models/interfaces/iUpcomingEvents';

const mutations: MutationTree<State> = {
  [SET_EVENTS_DATA](state: State, data: IUpcomingEvents): void {
    const upcomingEventsData: any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined)
        _acc[key] = data[key];

      return _acc;
    }, {})

    state.upcomingEvents = upcomingEventsData;
  },
  [SET_UPDATE_SHORTLISTED_EVENT_DATA](state: State, data: IUpcomingEvents): void {
    const upcomingEventsData: any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined)
        _acc[key] = data[key];

      return _acc;
    }, {})

    state.upcomingEvents = upcomingEventsData;
  },

};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/events/mutations.ts